<template>
  <div class="h-20 md:hidden"></div>
  <nav class="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-sm shadow-xl z-50 border-t border-gray-100 md:hidden">
    <div class="flex justify-around items-center py-3 max-w-2xl mx-auto px-4">
      <div 
        v-for="item in computedNavItems" 
        :key="item.name" 
        class="flex flex-col items-center space-y-1 cursor-pointer group"
        :class="{ 'text-blue-600': isActive(item) }"
        @click="setActive(item)"
      >
        <template v-if="item.icon && !(loggedIn && item.name === 'Profile')">
          <div class="relative">
            <span 
              class="material-symbols-outlined text-2xl transition-all duration-300 ease-out"
              :class="{
                'scale-110': isActive(item),
                'group-hover:scale-110 group-hover:text-blue-500': !isActive(item)
              }"
              :style="isActive(item) ? { fontVariationSettings: '\'FILL\' 1' } : null"
            >{{ item.icon }}</span>
            <div 
              v-if="isActive(item)"
              class="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-blue-600 rounded-full"
            ></div>
          </div>
        </template>

        <template v-else-if="loggedIn && item.name === 'Profile'">
          <div class="relative">
            <img 
              v-if="item.image"
              :src="item.image"
              alt="Profile" 
              class="w-8 h-8 rounded-full object-cover border-2 transition-all duration-300 ease-out ring-2 ring-white"
              :class="isActive(item) 
                ? 'border-blue-600 scale-110 ring-blue-100' 
                : 'border-gray-200 group-hover:scale-110 group-hover:border-blue-400'"
            />
            <span
              v-else
              class="w-8 h-8 rounded-full bg-blue-100 text-blue-700 border-2 transition-all duration-300 ease-out ring-2 ring-white flex items-center justify-center text-xs font-semibold"
              :class="isActive(item) 
                ? 'border-blue-600 scale-110 ring-blue-100' 
                : 'border-gray-200 group-hover:scale-110 group-hover:border-blue-400'"
            >
              {{ profileInitials }}
            </span>
            <div 
              v-if="isActive(item)"
              class="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-blue-600 rounded-full"
            ></div>
          </div>
        </template>

        <span 
          class="text-xs font-medium font-sans transition-colors duration-300"
          :class="{
            'text-gray-500 group-hover:text-gray-700': !isActive(item),
            'text-blue-600': isActive(item)
          }"
        >{{ item.label }}</span>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      baseNavItems: [
        {
          name: 'Timetable',
          label: 'Timetable',
          icon: 'schedule',
          routes: ['/timetable']
        },
        {
          name: 'Bus',
          label: 'Bus',
          icon: 'departure_board',
          routes: ['/bus']
        },
        {
          name: 'Resources',
          label: 'Resources',
          icon: 'auto_stories',
          routes: ['/resources']
        },
        {
          name: 'Socials',
          label: 'Socials',
          icon: 'diversity_3',
          routes: ['/socials', '/posts', '/chat', '/hustleup']
        }
      ]
    };
  },
  computed: {
    ...mapState(['user', 'profile']),
    loggedIn() {
      return !!this.user;
    },
    profileInitials() {
      const name = this.profile?.name || this.user?.email || 'Account';
      return name
        .split(' ')
        .filter(Boolean)
        .map(part => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase() || 'A';
    },
    computedNavItems() {
      const items = [...this.baseNavItems];
      items.push(
        this.loggedIn
          ? {
              name: 'Profile',
              label: 'Profile',
              image: this.profile?.profilePicture || null,
              routes: ['/profile', '/upgrade', '/update-profile-picture', '/update-profile', '/update-business', '/change-password', '/delete-account'],
            }
          : {
              name: 'Profile',
              label: 'Profile',
              icon: 'account_circle',
              routes: ['/profile', '/upgrade']
            }
      );
      return items;
    }
  },
  methods: {
    isActive(item) {
      return item.routes.some(r => this.$route.path.startsWith(r));
    },
    setActive(item) {
      const mainRoute = item.routes[0];
      this.$router.push(mainRoute);
    }
  }
};
</script>
